import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import netBeautyBankPointsAvailableSelector from 'selectors/basket/netBeautyBankPointsAvailableSelector';
import Actions from 'Actions';

import userUtils from 'utils/User';
import { isActivityGroupingEnabled } from 'utils/BeautyInsider';
import beautyInsiderActions from 'actions/BeautyInsiderActions';
import rewardActions from 'actions/RewardActions';
import profileActions from 'actions/ProfileActions';
const { wrapHOC } = FrameworkUtils;
const { getAccountHistorySlice, getAccountActivityPoints } = profileActions;

const fields = createSelector(netBeautyBankPointsAvailableSelector, userSelector, (netBeautyBankPointsAvailable, user) => {
    return {
        netBeautyBankPointsAvailable,
        user,
        isBI: userUtils.isBI(),
        isSignedIn: userUtils.isSignedIn(),
        userIsInitialized: user.isInitialized,
        isAtLeastRecognized: user.isInitialized && userUtils.isUserAtleastRecognized(),
        isAnonymous: user.isInitialized && userUtils.isAnonymous(),
        isActivityGroupingEnabled: isActivityGroupingEnabled()
    };
});

const functions = dispatch => ({
    fetchBiRewards: () => dispatch(beautyInsiderActions.fetchBiRewards()),
    fetchClientSummary: includeCampaigns => dispatch(beautyInsiderActions.fetchClientSummary(includeCampaigns)),
    fetchRecentlyRedeemedRewards: profileId => dispatch(rewardActions.fetchRecentlyRedeemedRewards(profileId, { purchaseFilter: 'rewards' })),
    getAccountHistorySlice: () => dispatch(getAccountHistorySlice(0, 4)),
    getAccountActivityPoints: (profileId, pageSize) => dispatch(getAccountActivityPoints(profileId, pageSize)),
    fetchBeautyOffers: (country, language) => dispatch(beautyInsiderActions.getBeautyOffers(country, language)),
    showPasskeyOptinModal: args => dispatch(Actions.showPasskeyOptinModal(args))
});

const withBeautyInsiderProps = wrapHOC(connect(fields, functions));

export {
    withBeautyInsiderProps, fields, functions
};
